/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  TerminalApplicationStatus,
  TerminalApplicationStatus$inboundSchema,
  TerminalApplicationStatus$outboundSchema,
} from "./terminalapplicationstatus.js";

export type WebhookDataTerminalApplicationUpdated = {
  terminalApplicationID: string;
  /**
   * Status of the terminal application.
   */
  status: TerminalApplicationStatus;
};

/** @internal */
export const WebhookDataTerminalApplicationUpdated$inboundSchema: z.ZodType<
  WebhookDataTerminalApplicationUpdated,
  z.ZodTypeDef,
  unknown
> = z.object({
  terminalApplicationID: z.string(),
  status: TerminalApplicationStatus$inboundSchema,
});
/** @internal */
export type WebhookDataTerminalApplicationUpdated$Outbound = {
  terminalApplicationID: string;
  status: string;
};

/** @internal */
export const WebhookDataTerminalApplicationUpdated$outboundSchema: z.ZodType<
  WebhookDataTerminalApplicationUpdated$Outbound,
  z.ZodTypeDef,
  WebhookDataTerminalApplicationUpdated
> = z.object({
  terminalApplicationID: z.string(),
  status: TerminalApplicationStatus$outboundSchema,
});

export function webhookDataTerminalApplicationUpdatedToJSON(
  webhookDataTerminalApplicationUpdated: WebhookDataTerminalApplicationUpdated,
): string {
  return JSON.stringify(
    WebhookDataTerminalApplicationUpdated$outboundSchema.parse(
      webhookDataTerminalApplicationUpdated,
    ),
  );
}
export function webhookDataTerminalApplicationUpdatedFromJSON(
  jsonString: string,
): SafeParseResult<WebhookDataTerminalApplicationUpdated, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) =>
      WebhookDataTerminalApplicationUpdated$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'WebhookDataTerminalApplicationUpdated' from JSON`,
  );
}
